module.exports = __webpack_public_path__ + "login_flag-3f70dda8f510ae694bd46616962750bd.gif";